export enum SideMenuMode {
  Overlay = 'Overlay',
  Push = 'Push',
}
